/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NetworkIdentifier,
    NetworkIdentifierFromJSON,
    NetworkIdentifierFromJSONTyped,
    NetworkIdentifierToJSON,
    RosettaMaxFeeAmount,
    RosettaMaxFeeAmountFromJSON,
    RosettaMaxFeeAmountFromJSONTyped,
    RosettaMaxFeeAmountToJSON,
    RosettaOperation,
    RosettaOperationFromJSON,
    RosettaOperationFromJSONTyped,
    RosettaOperationToJSON,
} from './';

/**
 * ConstructionPreprocessRequest is passed to the /construction/preprocess endpoint so that a Rosetta implementation can determine which metadata it needs to request for construction
 * @export
 * @interface RosettaConstructionPreprocessRequest
 */
export interface RosettaConstructionPreprocessRequest {
    /**
     * 
     * @type {NetworkIdentifier}
     * @memberof RosettaConstructionPreprocessRequest
     */
    network_identifier: NetworkIdentifier;
    /**
     * 
     * @type {Array<RosettaOperation>}
     * @memberof RosettaConstructionPreprocessRequest
     */
    operations: Array<RosettaOperation>;
    /**
     * 
     * @type {object}
     * @memberof RosettaConstructionPreprocessRequest
     */
    metadata?: object;
    /**
     * 
     * @type {Array<RosettaMaxFeeAmount>}
     * @memberof RosettaConstructionPreprocessRequest
     */
    max_fee?: Array<RosettaMaxFeeAmount>;
    /**
     *  The caller can also provide a suggested fee multiplier to indicate that the suggested fee should be scaled. This may be used to set higher fees for urgent transactions or to pay lower fees when there is less urgency. It is assumed that providing a very low multiplier (like 0.0001) will never lead to a transaction being created with a fee less than the minimum network fee (if applicable). In the case that the caller provides both a max fee and a suggested fee multiplier, the max fee will set an upper bound on the suggested fee (regardless of the multiplier provided).
     * @type {number}
     * @memberof RosettaConstructionPreprocessRequest
     */
    suggested_fee_multiplier?: number;
}

export function RosettaConstructionPreprocessRequestFromJSON(json: any): RosettaConstructionPreprocessRequest {
    return RosettaConstructionPreprocessRequestFromJSONTyped(json, false);
}

export function RosettaConstructionPreprocessRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RosettaConstructionPreprocessRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'network_identifier': NetworkIdentifierFromJSON(json['network_identifier']),
        'operations': ((json['operations'] as Array<any>).map(RosettaOperationFromJSON)),
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
        'max_fee': !exists(json, 'max_fee') ? undefined : ((json['max_fee'] as Array<any>).map(RosettaMaxFeeAmountFromJSON)),
        'suggested_fee_multiplier': !exists(json, 'suggested_fee_multiplier') ? undefined : json['suggested_fee_multiplier'],
    };
}

export function RosettaConstructionPreprocessRequestToJSON(value?: RosettaConstructionPreprocessRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'network_identifier': NetworkIdentifierToJSON(value.network_identifier),
        'operations': ((value.operations as Array<any>).map(RosettaOperationToJSON)),
        'metadata': value.metadata,
        'max_fee': value.max_fee === undefined ? undefined : ((value.max_fee as Array<any>).map(RosettaMaxFeeAmountToJSON)),
        'suggested_fee_multiplier': value.suggested_fee_multiplier,
    };
}

